export default __webpack_public_path__ + "i18n/translations/translation-bn.68a3fc48.json";